import Perspective from './perspective-model'
import {sectionEndpoint} from 'scoreboard/components/bootslide/object-selector-menu'
import i18n from 'scoreboard/components/i18n'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'

var DEFAULT_FONTSIZE = '16'
var DEFAULT_LABEL_DIRECTION = 'horizontal'

export default function (bootslideMenu) {
	var label = 'scorecards.node.perspective'
	return {
		label: i18n.get(label),
		content: option('add-widget-perspective', label + '.tileLabel'),
		contentEndpoint: sectionEndpoint(bootslideMenu, 'scorecards', AddOption)
	}
}

var AddOption = AddDomainObjectEndpoint.extend({
	allowSelect: function (node) {
		return node.type == 'perspective'
	},

	add: function (node) {
		var widget = new Perspective(
			{
				properties: {
					type: 'perspective',
					scorecardItemId: node.id,
					fontSize: DEFAULT_FONTSIZE,
					labelDirection: DEFAULT_LABEL_DIRECTION
				}
			},
			{
				domainObject: node
			})

		createWob(this.canvas, widget, { fetchData: true }, this.bootslideMenu)
	}
})
